import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './CopyEmailsField.module.scss';

const CopyEmailsField: React.FC = () => {
	const { report } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="emailCopyLabel" theme="neutralLight" size="xs" />
			<div className={style.copyEmailsList}>
				{report?.copyEmails.length
					? report.copyEmails.map((el, i) => {
							return (
								<div key={el + String(i)} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default CopyEmailsField;
